import { useTranslations } from "adapters/i18n";

export const useMonths = () => {
  const { t } = useTranslations();

  const months = [
    {
      Nome: t("common:months.january"),
      Id: "january",
      Label: t("common:months.jan"),
    },
    {
      Nome: t("common:months.february"),
      Id: "february",
      Label: t("common:months.feb"),
    },
    {
      Nome: t("common:months.march"),
      Id: "march",
      Label: t("common:months.mar"),
    },
    {
      Nome: t("common:months.april"),
      Id: "april",
      Label: t("common:months.apr"),
    },
    {
      Nome: t("common:months.may"),
      Id: "may",
      Label: t("common:months.mayShort"),
    },
    {
      Nome: t("common:months.june"),
      Id: "june",
      Label: t("common:months.jun"),
    },
    {
      Nome: t("common:months.july"),
      Id: "july",
      Label: t("common:months.jul"),
    },
    {
      Nome: t("common:months.august"),
      Id: "august",
      Label: t("common:months.aug"),
    },
    {
      Nome: t("common:months.september"),
      Id: "september",
      Label: t("common:months.sep"),
    },
    {
      Nome: t("common:months.october"),
      Id: "october",
      Label: t("common:months.oct"),
    },
    {
      Nome: t("common:months.november"),
      Id: "november",
      Label: t("common:months.nov"),
    },
    {
      Nome: t("common:months.december"),
      Id: "december",
      Label: t("common:months.dec"),
    },
  ];

  return months;
};
